import { useState } from "react";
import { Input, Form, Modal, Typography, Tag, Space, InputNumber } from "antd";

import CustomSelect from "@/components/inputs/CustomSelect";

import { createItem, updateItem } from "@/api/statuses";
import { STATUS_OPTIONS } from "@/constants/tasks";

const { Text } = Typography;

// Окно для создания/редактирования статуса, содержит форму
const StatusModal = ({ data = {}, visible, onSave, onCancel }) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getIcon = (color) => {
    return STATUS_OPTIONS.find((item) => item.value === color)?.icon;
  };

  const handleCancel = () => {
    form.resetFields();
    setError(null);
    onCancel();
  };

  const handleSave = async (values) => {
    setError(null);
    setIsLoading(true);

    try {
      if (data.uuid) {
        await updateItem({ ...data, ...values });
      } else {
        await createItem(values);
      }

      onSave();
      form.resetFields();
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSave(values);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      maskClosable={false}
      title={
        data.uuid
          ? "Редактирование статуса задачи"
          : "Добавление нового статуса задачи"
      }
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText={data.uuid ? "Сохранить" : "Добавить"}
      cancelText="Отмена"
      okButtonProps={{ loading: isLoading }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
        onFinish={handleSave}
      >
        <Form.Item
          name="name"
          label="Название"
          rules={[{ required: true, message: "Пожалуйста, введите название" }]}
        >
          <Input />
        </Form.Item>
        <Space>
          <Form.Item name="idx" label="Номер по порядку">
            <InputNumber />
          </Form.Item>
          <Form.Item name="color" label="Внешний вид">
            <CustomSelect
              options={STATUS_OPTIONS}
              optionRender={(option) => (
                <Tag
                  icon={option?.data?.icon}
                  color={option.value}
                  className="tag-with-icon-color"
                >
                  статус
                </Tag>
              )}
              optionFilterProp="value"
              labelRender={(option) => (
                <Tag
                  icon={getIcon(option.value)}
                  color={option.value}
                  className="tag-with-icon-color"
                >
                  статус
                </Tag>
              )}
              style={{ width: 120 }}
            />
          </Form.Item>
        </Space>

        {error && (
          <div>
            <Text type="danger">{error}</Text>
          </div>
        )}
      </Form>
    </Modal>
  );
};

export default StatusModal;
